module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchOrder":"Search order"},"no":{"searchOrder":"Søk oppdrag"}}')
  delete Component.options._Ctor
}
